import dayjs from 'dayjs';

import {
  END_OF_DAY_HOUR,
  END_OF_DAY_MINUTE,
  END_OF_DAY_SECOND,
} from '@constants';

export const getCurrentDateStartEndTime = (
  point: 'end' | 'start',
  timezone: string
) =>
  point === 'start'
    ? dayjs().tz(timezone).hour(0).minute(0).second(0).utc()
    : dayjs()
        .tz(timezone)
        .hour(END_OF_DAY_HOUR)
        .minute(END_OF_DAY_MINUTE)
        .second(END_OF_DAY_SECOND)
        .utc();
